import { Add, Delete } from "@mui/icons-material";
import { Button, IconButton, Paper } from "@mui/material";
import React from "react";
import { useFieldArray, useFormContext } from "react-hook-form";

interface ArrayFieldProps {
  extractionId: string;
  FormField: React.FC<{
    extractionId: string;
    extractionPath?: string;
    label?: string;
    key?: string;
  }>;
  getDefaultValue: Function;
}

const ArrayField: React.FC<ArrayFieldProps> = ({
  extractionId,
  FormField,
  getDefaultValue,
}) => {
  const { control } = useFormContext();
  const { fields, append, remove } = useFieldArray({
    control,
    name: `extraction.${extractionId}.value`,
  });

  return (
    <div className="flex flex-col gap-2">
      {fields.map((_field, index) => {
        return (
          <Paper className="flex justify-between p-4 gap-2" key={_field.id}>
            <FormField
              extractionId={extractionId}
              extractionPath={`${index}`}
            />
            <IconButton
              onClick={() => {
                remove(index);
              }}
              className="rounded-full"
              aria-label="Delete an element"
            >
              <Delete color="error" />
            </IconButton>
          </Paper>
        );
      })}
      <Button
        onClick={() => {
          append(getDefaultValue());
        }}
        className="rounded-full"
        aria-label="Add an element"
        variant="outlined"
      >
        <Add fontSize="small" />
      </Button>
    </div>
  );
};

export default ArrayField;
